webpackJsonp([131228626835845],{

/***/ 394:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Stripeo and Amaza the Pirate Princess","author":"Ola Vea","feedbackFormLabels":{"title":"Hei, se her!","message":"På denne siden er det ingen spioner (ingen cookies, ingen analyseverktøy, nadanix) som ser deg. Derfor er det fint om du melder fra i skjema under om du syntes artikkelen var nyttig (eller ei).","name":"Navn","email":"E-post","textarea":"Beskjed","newsletter":"Jeg ønsker å få nyhetsbrev når det kommer nytt innhold","submit":"Send"}}},"markdownRemark":{"id":"/opt/build/repo/content/posts/glasur/index.md absPath of file >>> MarkdownRemark","html":"","fields":{"slug":"/glasur/"},"frontmatter":{"title":"Part 2"}}},"pathContext":{"slug":"/glasur/","previous":{"fields":{"slug":"/hei-lo-mammaen-min-kan-mer-om-it-enn-dere/"},"frontmatter":{"title":"Part 3"}},"next":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---glasur-142e6f369194d59402c7.js